  
  export const paymentFrequencyEnum = ["monthly", "quarterly", "yearly"] as const;
  
  export const SaleType = ["Buy", "Sell", "Buy_Sell"] as const;
  
  export const StockCategoryType = ["Goods", "Services", "Assets"] as const;
  


